import { render, staticRenderFns } from "./FeaturedApartments.vue?vue&type=template&id=bc1b2f20&"
import script from "./FeaturedApartments.vue?vue&type=script&lang=js&"
export * from "./FeaturedApartments.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedApartments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports